import ApiService from '@/services/api.service'

const Companies = {

    getAll(){
        return ApiService.get('/Companies');
    },

    getLookUp(){
        return ApiService.get('/Companies/LookUp');
    },

    getCompanyStorage(){
        return ApiService.get('/Companies/storage');
    },

    get( id) {
        return ApiService.get(`/Companies/${id}`);
    },

    update(company) { 
        const requestData = {
          method: 'put',
          url: `/Companies/update`,
          headers: {},
          data: company
        }
        return ApiService.customRequest(requestData);
    },

    updateSqlpassword(sqlpassword) { 
        const requestData = {
          method: 'put',
          url: `/Companies/sqlPass`,
          headers: {},
          data:  sqlpassword 
        }
        return ApiService.customRequest(requestData);
    }
}

export default Companies;